import axios from '@fs/zion-axios'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'

/**
  Set the availability of a support expert
  @param {Object} data The data provided to the function
  @param {String} data.cisUserId The expert's CIS ID
  @param {Boolean} data.isAvailable Whether the expert is currently available
  @returns {Promise} A Promise that resolves when the request is complete (a 204 is provided by the backend in either case, indicating success with no other data to send back)
 */
export const updateSupportExpertAvailability = ({ cisUserId, isAvailble }) => {
  return axios({
    method: isAvailble ? 'PUT' : 'DELETE',
    url: `${serviceBaseUrl}/support/experts/${cisUserId}/available`,
  })
}

/**
  Set a support expert as trained
  @param {Object} data The data provided to the function
  @param {String} data.cisUserId The expert's CIS ID
    @param {Boolean} data.isTrained Whether the expert is currently trained
  @returns {Promise} A Promise that resolves when the request is complete (a 204 is provided by the backend in either case, indicating success with no other data to send back)
 */
export const updateSupportExpertTrained = ({ cisUserId, isTrained }) => {
  return axios({
    method: isTrained ? 'PUT' : 'DELETE',
    url: `${serviceBaseUrl}/support/experts/${cisUserId}/trained`,
  })
}

/**
  Delete a support expert
  @param {String} data.cisUserId The expert's CIS ID
  @returns {Promise} A Promise that resolves when the request is complete (a 204 is provided by the backend in either case, indicating success with no other data to send back)
 */
export const deleteSupportExpert = ({ cisUserId }) => {
  return axios({
    method: 'DELETE',
    url: `${serviceBaseUrl}/support/experts/${cisUserId}`,
  })
}

/**
 * Get info from the backend about a support expert, such as availability and expertise
 * @param {Object} data The data provided to the function
 * @param {String} data.cisUserId The expert's CIS ID
 * @returns {Promise} A Promise resolving to the expert's information
 */
export const getSupportExpertInfo = ({ cisUserId }) => {
  return axios({
    method: 'GET',
    url: `${serviceBaseUrl}/support/experts/${cisUserId}`,
  })
}
/**
 * update info from the backend about a support expert, such as availability and expertise
 * @param {Object} data The data provided to the function {"languages": ["..."], "supportCategories": ["..."]}
 * @param {String} data.cisUserId The expert's CIS ID
 * @returns {Promise} A Promise resolving to the expert's information
 */
export const updateSupportExpertInfo = ({ isExpert, cisUserId, data }) => {
  return axios({
    method: !isExpert ? 'POST' : 'PUT',
    url: `${serviceBaseUrl}/support/experts/${cisUserId}`,
    data,
  })
}
